module.exports = __webpack_public_path__ + "static/media/Gardine.1ecd338f.mp3";